import * as React from "react";
import { observer } from 'mobx-react';
import { makeObservable, observable } from 'mobx';
import { Ajax2 } from '@shared/Ajax';
import { PdfViewer } from './PdfViewer';
import { Button } from '@shared/ui-react/Button';


@observer
export class PdfTemplateFill extends React.Component<{
    onSaved?: (doc: IDocument) => void;
    onClose?: () => void;
    latLon?: [number, number];
    getRenamedName?: (template: string, description: string, folderUuid: string, latLon: [number, number], doc: IDocument) => string;
    getUserLatLon?: () => [number, number];
    openSavedPdfInFolder?: (documentUuid: string) => void;
    openSavedPdfOnMap?: (documentUuid: string) => void;
}> {
    @observable templates = null;
    @observable selectedTemplate: IReportTemplate = null;
    @observable isLoading = false;

    constructor(props) {
        super(props);
        makeObservable(this);

        this.fetch();
    }

    fetch() {
        this.isLoading = true;
        Ajax2({
            url: kuura.getContextPath() + '/api/1/report-templates.json?projectId=' + kuura.getProjectId(),
        })
            .then(resp => {
                this.templates = resp.templates;
                this.isLoading = false;
            })
            .catch(e => {
                this.isLoading = false;
            })
    }

    render() {
        if (this.isLoading) {
            return (
                <div className='overlay-loading' style={{ minWidth: 300, minHeight: 200, width: '100%' }}></div>
            )
        }

        if (this.templates?.length == 0) {
            return (
                <div className='padded text-center'>
                    <div>{__('js_files.no_templates')}</div>
                </div>
            )
        }

        const pdfUrl = kuura.getContextPath() + `/api/1/report-template/${this.selectedTemplate?.id}/file`;
        return (
            <div className='flex-row gap of-a' style={{ flexGrow: 1, height: '100%', marginTop: 10 }}>
                {!this.selectedTemplate ?
                    <aside className='flex-column gap-half padded'>
                        {this.templates.map(t => <Button key={t.id} onClick={() => this.selectedTemplate = t}>{t.name}</Button>)}
                    </aside>
                    :
                    <main className='flex-column' style={{ width: 'min(100vw, 1200px)', height: '100%' }}>
                        <PdfViewer
                            pdfUrl={pdfUrl}
                            canFill={true}
                            documentUuid={this.selectedTemplate?.documentUuid}
                            templateId={this.selectedTemplate?.id}
                            getRenamedName={this.props.getRenamedName}
                            getUserLatLon={this.props.getUserLatLon}
                            mapMarkerLatLon={this.props.latLon}
                            openSavedPdfInFolder={this.props.openSavedPdfInFolder}
                            openSavedPdfOnMap={this.props.openSavedPdfOnMap}
                            onSaveSuccess={this.props.onSaved}
                            onClose={() => this.selectedTemplate = null} />
                    </main>
                }
            </div>
        );
    }
}
